var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #121331;\r\n      }\r\n\r\n      .cls-3, .cls-6 {\r\n        fill: #ebe6ef;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        fill: #4bb3fd;\r\n      }\r\n\r\n      .cls-5, .cls-6 {\r\n        mix-blend-mode: multiply;\r\n        opacity: 0.5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.33,301.14H26.49a3.5,3.5,0,0,1,0-7h80.84a3.5,3.5,0,0,1,0,7Zm.2-41.25H26.69a3.5,3.5,0,1,1,0-7h80.84a3.5,3.5,0,0,1,0,7Zm0-41.75H26.69a3.5,3.5,0,1,1,0-7h80.84a3.5,3.5,0,0,1,0,7Zm-.15-41.25H26.54a3.5,3.5,0,1,1,0-7h80.84a3.5,3.5,0,0,1,0,7Zm0-41.75H26.54a3.5,3.5,0,1,1,0-7h80.84a3.5,3.5,0,0,1,0,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.52,134V296a2.37,2.37,0,0,1-2.37,2.37h-247a2.37,2.37,0,0,1-2.37-2.37V134a2.34,2.34,0,0,1,.7-1.67,2.3,2.3,0,0,1,1.67-.7h13.55l233.44,0a2.33,2.33,0,0,1,1.67.69A2.36,2.36,0,0,1,403.52,134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.82,132.35l-104.6,105a29.21,29.21,0,0,1-41.34,0l-17.64-17.74-.14-.14-86.61-87.09a2.3,2.3,0,0,1,1.67-.7h13.55l233.44,0A2.33,2.33,0,0,1,402.82,132.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.09,237.31l-17.65-17.74-86.75-87.23c-.28-.28-.49-.5-.67-.7H154.16a2.3,2.3,0,0,0-1.67.7l86.75,87.23,17.64,17.74a29.18,29.18,0,0,0,24.78,8.28,28.85,28.85,0,0,0,4-.87A29,29,0,0,1,273.09,237.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.24,219.57l-87.45,73.18V282.58l66.45-58.39a82.87,82.87,0,0,1,15.14-10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M403.52,282.63v10.13l-87.47-73.19,5.87-5.81a83.22,83.22,0,0,1,15.14,10.43l66.44,58.39Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.fbf2b359fbd714c2b959c5bdf6a658f8.svg";
export { ForwardRef as ReactComponent };